'use strict';

define(['providers/providers', 'plugins/plugins', 'playlist/loader', 'utils/scriptloader', 'utils/constants', 'utils/underscore', 'utils/helpers', 'events/events', 'utils/strings', 'version'], function (Providers, plugins, PlaylistLoader, ScriptLoader, Constants, _, utils, events, strings, version) {

    var _pluginLoader, _playlistLoader;

    function getQueue() {

        var Components = {
            LOAD_PROMISE_POLYFILL: {
                method: _loadPromisePolyfill,
                depends: []
            },
            LOAD_BASE64_POLYFILL: {
                method: _loadBase64Polyfill,
                depends: []
            },
            LOAD_JSON2: {
                method: _loadJson2,
                depends: []
            },
            LOADED_POLYFILLS: {
                method: _loadedPolyfills,
                depends: ['LOAD_PROMISE_POLYFILL', 'LOAD_BASE64_POLYFILL', 'LOAD_JSON2']
            },
            LOAD_PLUGINS: {
                method: _loadPlugins,
                depends: ['LOADED_POLYFILLS']
            },
            INIT_PLUGINS: {
                method: _initPlugins,
                depends: ['LOAD_PLUGINS',
                // Init requires jw-overlays to be in the DOM
                'SETUP_VIEW']
            },
            LOAD_FLVJS: {
                method: _loadFlvjs,
                depends: []
            },
            LOAD_VIDEOJS_LEVELS: {
                method: _loadVideojsLevels,
                depends: ['LOAD_VIDEOJS_HLS']
            },
            LOAD_VIDEOJS_HLS: {
                method: _loadVideojsHls,
                depends: ['LOAD_VIDEOJS']
            },
            LOAD_VIDEOJS: {
                method: _loadVideojs,
                depends: []
            },
            LOAD_PROVIDERS: {
                method: _loadProviders,
                depends: ['FILTER_PLAYLIST']
            },
            LOAD_SKIN: {
                method: _loadSkin,
                depends: ['LOADED_POLYFILLS']
            },
            LOAD_PLAYLIST: {
                method: _loadPlaylist,
                depends: ['LOADED_POLYFILLS']
            },
            FILTER_PLAYLIST: {
                method: _filterPlaylist,
                depends: ['LOAD_PLAYLIST', 'LOAD_FLVJS', 'LOAD_VIDEOJS_LEVELS'] // 此时先安装播放器插件
            },
            SETUP_VIEW: {
                method: _setupView,
                depends: ['LOAD_SKIN']
            },
            SEND_READY: {
                method: _sendReady,
                depends: ['INIT_PLUGINS', 'LOAD_PROVIDERS', 'SETUP_VIEW']
            }
        };

        return Components;
    }

    function _loadPromisePolyfill(resolve) {
        if (!window.Promise) {
            require.ensure(['polyfills/promise'], function (require) {
                require('polyfills/promise');
                resolve();
            }, 'polyfills.promise');
        } else {
            resolve();
        }
    }

    function _loadBase64Polyfill(resolve) {
        if (!window.btoa || !window.atob) {
            require.ensure(['polyfills/base64'], function (require) {
                require('polyfills/base64');
                resolve();
            }, 'polyfills.base64');
        } else {
            resolve();
        }
    }

    function _loadJson2(resolve) {
        if (!window.JSON) {
            require.ensure(['polyfills/json2'], function (require) {
                require('polyfills/json2');
                resolve();
            }, 'polyfills.json2');
        } else {
            resolve();
        }
    }

    function _loadFlvjs(resolve, model) {
        var playlist = model.get('playlist');
        if (utils.isFlvjsSupported() && (utils.isFlv(playlist[0].file) || playlist[0].sources && utils.isFlv(playlist[0].sources[0].file))) {
            require.ensure(['flvjs/index'], function (require) {
                require('flvjs/index');
                resolve();
            }, 'flv');
        } else {
            resolve();
        }
    }

    function isNeedLoadVideojs(playlist) {
        return !__DEBUG__ && utils.isFlvjsSupported() && !utils.isMobile() && (utils.isHls(playlist[0].file) || playlist[0].sources && utils.isHls(playlist[0].sources[0].file));
    }

    function _loadVideojsLevels(resolve, model) {
        var playlist = model.get('playlist');
        if (isNeedLoadVideojs(playlist) && window.videojs && !window.videojs.getPlugin('qualityLevels') && !model.get('isLive')) {
            var loader = new ScriptLoader('' + Constants.repo + version + '/videojs/videojs-contrib-quality-levels.min.js', false);
            loader.addEventListener(events.COMPLETE, function () {
                resolve();
            });
            loader.load();
        } else {
            resolve();
        }
    }

    function _loadVideojsHls(resolve, model) {
        var playlist = model.get('playlist');
        if (isNeedLoadVideojs(playlist) && window.videojs && !window.videojs.m3u8) {
            var loader = new ScriptLoader('' + Constants.repo + version + '/videojs/videojs-contrib-hls.min.js', false);
            loader.addEventListener(events.COMPLETE, function () {
                resolve();
            });
            loader.load();
        } else {
            resolve();
        }
    }

    function _loadVideojs(resolve, model) {
        var playlist = model.get('playlist');
        if (isNeedLoadVideojs(playlist) && !window.videojs) {
            var loader = new ScriptLoader('' + Constants.repo + version + '/videojs/video.min.js', false);
            loader.addEventListener(events.COMPLETE, function () {
                resolve();
            });
            loader.load();
        } else {
            resolve();
        }
    }

    function _loadedPolyfills(resolve) {
        resolve();
    }

    function _loadPlugins(resolve, _model) {
        _pluginLoader = plugins.loadPlugins(_model.get('id'), _model.get('plugins'));
        _pluginLoader.on(events.COMPLETE, resolve);
        _pluginLoader.on(events.ERROR, _.partial(_pluginsError, resolve));
        _pluginLoader.load();
    }

    function _initPlugins(resolve, _model, _api) {
        _pluginLoader.setupPlugins(_api, _model);

        resolve();
    }

    function _pluginsError(resolve, evt) {
        error(resolve, 'Could not load plugin', evt.message);
    }

    function _loadPlaylist(resolve, _model) {
        var playlist = _model.get('playlist');
        if (_.isString(playlist)) {
            _playlistLoader = new PlaylistLoader();
            _playlistLoader.on(events.JWPLAYER_PLAYLIST_LOADED, function (data) {
                _model.set('playlist', data.playlist);
                _model.set('feedid', data.feedid);
                resolve();
            });
            _playlistLoader.on(events.JWPLAYER_ERROR, _.partial(_playlistError, resolve));
            _playlistLoader.load(playlist);
        } else {
            resolve();
        }
    }

    function _filterPlaylist(resolve, _model, _api, _view, _setPlaylist) {
        var playlist = _model.get('playlist');

        // Performs filtering
        var success = _setPlaylist(playlist);

        if (success) {
            resolve();
        } else {
            var evt = {};
            // 对于一些未知错误给出明确提示
            var errorEvent = getUnknownErrorMessage(playlist);
            evt.message = errorEvent.errorMessage;
            evt.code = errorEvent.errorCode;

            if (evt.code === '111') {
                _mediaError(resolve, evt);
            } else {
                _playerError(resolve, evt);
            }
        }
    }

    function getUnknownErrorMessage(playlist) {
        var errorMessage = '';
        var errorCode = '';

        if (!utils.flashVersion() && !utils.isMobile()) {
            // 没有安装flash提示
            errorMessage = '未检测到Flash Player，请到' + '<a href="https://get.adobe.com/cn/flashplayer/" target="_blank">安装</a>';
            errorCode = '101';
        } else if (utils.flashVersion() && utils.flashVersion() < 11.2) {
            errorMessage = 'Flash Player版本必须大于11.2, ' + '<a href="https://get.adobe.com/cn/flashplayer/" target="_blank">更新Flash Player</a>';
            errorCode = '102';
        } else if (utils.isMobile() && (utils.isRtmp(playlist[0].file) || utils.isFlv(playlist[0].file))) {
            errorMessage = '手机上不能播放rtmp或flv格式的视频';
            errorCode = '111';
        }

        return {
            errorMessage: errorMessage,
            errorCode: errorCode
        };
    }

    function _mediaError(resolve, evt) {
        if (evt && evt.message) {
            error(resolve, '视频加载失败', evt.message, evt.code || '');
        }
    }

    function _playerError(resolve, evt) {
        if (evt && evt.message) {
            error(resolve, '播放器加载失败', evt.message, evt.code || '');
        }
    }

    function _playlistError(resolve, evt) {
        if (evt && evt.message) {
            error(resolve, '播放列表加载失败', evt.message);
        } else {
            error(resolve, '播放器加载失败', '未发现可播放的资源');
        }
    }

    function skinToLoad(skin, base) {
        if (_.contains(Constants.SkinsLoadable, skin)) {
            return base + 'skins/' + skin + '.css';
        }
    }

    function isSkinLoaded(skinPath) {
        var ss = document.styleSheets;
        for (var i = 0, max = ss.length; i < max; i++) {
            if (ss[i].href === skinPath) {
                return true;
            }
        }
        return false;
    }

    function _loadSkin(resolve, _model) {
        var skinName = _model.get('skin');
        var skinUrl = _model.get('skinUrl');

        // If skin is built into player, there is nothing to load
        if (_.contains(Constants.SkinsIncluded, skinName)) {
            resolve();
            return;
        }

        if (!skinUrl) {
            // if a user doesn't specify a url, we assume it comes from our CDN or config.base
            // 皮肤路径修改 zhangzhe 2017-03-22
            var base = __DEBUG__ ? _model.get('base') : Constants.repo;
            skinUrl = skinToLoad(skinName, base);
        }

        if (_.isString(skinUrl) && !isSkinLoaded(skinUrl)) {
            _model.set('skin-loading', true);

            var isStylesheet = true;
            var loader = new ScriptLoader(skinUrl, isStylesheet);

            loader.addEventListener(events.COMPLETE, function () {
                _model.set('skin-loading', false);
            });
            loader.addEventListener(events.ERROR, function () {
                _model.set('skin', 'bce'); // fall back to seven skin
                _model.set('skin-loading', false);
            });

            loader.load();
        }

        // Control elements are hidden by the loading flag until it is ready
        _.defer(function () {
            resolve();
        });
    }

    function _loadProviders(resolve, model) {
        var providersManager = model.getProviders();
        var playlist = model.get('playlist');

        var providersNeeded = providersManager.required(playlist);

        Providers.load(providersNeeded).then(resolve);
    }

    function _setupView(resolve, _model, _api, _view) {
        _view.setup();
        resolve();
    }

    function _sendReady(resolve) {
        resolve({
            type: 'complete'
        });
    }

    function error(resolve, msg, reason, code) {
        resolve({
            type: 'error',
            msg: msg,
            reason: reason,
            code: code || ''
        });
    }

    return {
        getQueue: getQueue,
        error: error
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controller/setup-steps.js
 ** module id = 69
 ** module chunks = 0
 **/